module.exports = __webpack_public_path__ + "static/media/guitar-electric.27752752.svg";